import axios, { AxiosError, AxiosRequestConfig } from "axios"
import {
  requestInterceptorErrorSecurityCredentials,
  requestInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials,
  responseInterceptorSuccessCredentials,
} from "interceptors"
import { FIELDS } from "lib"
import {
  DOCUMENT_FILE_PATH,
  DOWNLOAD_PATH,
  PDF_PATH,
  PURCHASE_ORDER_PATH,
} from "../../constants/paths"

const instance = axios.create({
  baseURL: process.env.REACT_APP_DOCUMENTS_API_SERVICE_DOMAIN,
})

instance.interceptors.request.use(
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials
)

instance.interceptors.response.use(
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials
)
const formDataConfig: AxiosRequestConfig = {
  headers: {
    "Content-Type": "multipart/form-data",
  },
}

export const uploadDocumentFileByDocumentIdService = async (
  file: any,
  documentId: any,
  description: any
) => {
  const formData = new FormData()
  formData.append(FIELDS.documentId.key, documentId.toString())
  formData.append(FIELDS.file.key, file)
  formData.append(FIELDS.description.key, description)
  try {
    const result = await instance.post(
      DOCUMENT_FILE_PATH,
      formData,
      formDataConfig
    )
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const uploadDocumentFileByDocumentIdServiceReimbursementInit = async (
  file: any,
  documentId: any,
  description: any
) => {
  const formData = new FormData()
  formData.append(FIELDS.documentId.key, documentId.toString())
  formData.append(FIELDS.file.key, file)
  formData.append(FIELDS.description.key, description)
  try {
    const result = await instance.post(
      DOCUMENT_FILE_PATH + "/init",
      formData,
      formDataConfig
    )
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const uploadPurchaseOrderDocumentFileByDocumentIdService = async (
  file: any,
  documentId: any,
  description: any
) => {
  const formData = new FormData()
  formData.append(FIELDS.documentId.key, documentId.toString())
  formData.append(FIELDS.file.key, file)
  formData.append(FIELDS.tag.key, description)
  try {
    const result = await instance.post(
      DOCUMENT_FILE_PATH + PURCHASE_ORDER_PATH,
      formData,
      formDataConfig
    )
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const downloadDocumentFileByIdService = async (documentFileId: any) => {
  try {
    const result = await instance.get(
      DOCUMENT_FILE_PATH + `/${documentFileId}`,
      { responseType: "blob" }
    )
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const downloadPdfByDocumentFileId = async (documentFileId: any) => {
  try {
    const result = await instance.get(
      DOCUMENT_FILE_PATH + DOWNLOAD_PATH + PDF_PATH + `/${documentFileId}`,
      { responseType: "blob" }
    )
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const deleteDocumentFileByIdService = async (documentFileId: any) => {
  try {
    const result = await instance.delete(
      DOCUMENT_FILE_PATH + `/${documentFileId}`
    )
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}
